"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalFvtDtoRelationshipToProbandEnum = void 0;
exports.InternalFvtDtoRelationshipToProbandEnum = {
    IsProband: 'is proband',
    Self: 'self',
    Sibling: 'sibling',
    Twin: 'twin',
    MaternalHalfSibling: 'maternal half sibling',
    PaternalHalfSibling: 'paternal half sibling',
    HalfSibling: 'half sibling',
    Child: 'child',
    Parent: 'parent',
    NieceNephew: 'niece/nephew',
    UncleAunt: 'uncle/aunt',
    Cousin: 'cousin',
    Grandchild: 'grandchild',
    Grandparent: 'grandparent',
    Partner: 'partner',
    Relative: 'relative'
};
